import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { SwiftCharacterMessageComponent } from './swift-character-message';


@NgModule({
    imports: [CommonModule, CommonDialogModule],
    declarations: [SwiftCharacterMessageComponent],
    exports: [SwiftCharacterMessageComponent]
})
export class SwiftCharacterMessageModule { }
